import {useEffect, useState} from 'react';
import {Link, useLocation} from 'react-router-dom';
import {Menu, X} from 'lucide-react';
import PabloLogo from './utils/PabloLogo';

const LINKS = [['/platform', 'Platform'], ['/pricing', 'Pricing'], ['/docs/create-your-first-plan', 'Docs'], ['/about', 'About']];

// One public navigation for the marketing pages and the embedded docs shell.
export default function Header({embedded = false, utilities = null, installHere = false}) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const light = embedded || isScrolled;
  const installHref = installHere ? '#install' : '/docs/install-pabs';
  useEffect(() => {
    const update = () => setIsScrolled(window.scrollY > 20);
    update();
    window.addEventListener('scroll', update, {passive: true});
    return () => window.removeEventListener('scroll', update);
  }, []);
  useEffect(() => setMobileMenuOpen(false), [location.pathname,location.hash]);
  const active = href => href.startsWith('/docs') ? location.pathname.startsWith('/docs') : location.pathname === href;
  const navClass = `rounded-md px-3 py-2 text-[13px] font-semibold transition-colors ${light ? 'text-brand-600 hover:text-brand-900' : 'text-brand-300 hover:text-brand-50'}`;
  return <header className={`${embedded ? 'relative flex-none py-3' : `fixed left-0 right-0 top-0 ${isScrolled ? 'py-3' : 'py-6'}`} z-50 font-inter`}>
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className={`relative flex h-14 items-center justify-between rounded-full px-4 sm:px-6 ${light ? 'bg-brand-50 text-brand-900' : 'text-brand-50'}`}>
        <div className="flex items-center gap-8">
          <Link to="/" aria-label="Pabs home" className="flex items-center gap-2 text-inherit">
            <div className="relative h-8 w-8" style={{'--stroke-0': light ? '#171923' : '#f7fafc', '--fill-0': light ? '#171923' : '#f7fafc'}}><PabloLogo/></div>
            <span className="text-xl font-bold tracking-tighter">Pabs</span>
          </Link>
          <nav aria-label="Public navigation" className="hidden items-center gap-1 md:flex">
            {LINKS.map(([href, label]) => <Link key={href} to={href} aria-current={active(href) ? 'page' : undefined} className={`${navClass} ${active(href) ? 'underline underline-offset-4' : ''}`}>{label}</Link>)}
          </nav>
        </div>
        <div className="flex items-center gap-3 sm:gap-5">
          {utilities}
          <Link to="/login" className={`hidden md:inline-block ${navClass}`}>Log in</Link>
          <Link to={installHref} className={`inline-flex h-10 items-center rounded-full px-4 text-[13px] font-semibold sm:px-6 ${light ? 'bg-brand-900 text-brand-50 hover:bg-brand-700' : 'bg-brand-50 text-brand-900 hover:bg-brand-200'}`}>Install Pabs</Link>
          <button type="button" onClick={() => setMobileMenuOpen(value => !value)} aria-label={mobileMenuOpen ? 'Close public menu' : 'Open public menu'} aria-expanded={mobileMenuOpen} aria-controls="public-mobile-menu" className="rounded-full p-2 md:hidden">{mobileMenuOpen ? <X size={20}/> : <Menu size={20}/>}</button>
        </div>
      </div>
      {mobileMenuOpen && <nav id="public-mobile-menu" aria-label="Public mobile navigation" className="mt-2 flex flex-col overflow-hidden rounded-2xl border border-brand-200 bg-brand-50 py-2 text-brand-900 md:hidden">
        {LINKS.map(([href, label]) => <Link key={href} to={href} aria-current={active(href) ? 'page' : undefined} className="px-6 py-3 text-sm font-semibold hover:bg-brand-200">{label}</Link>)}
        <Link to="/login" className="border-t border-brand-200 px-6 py-3 text-sm font-semibold hover:bg-brand-200">Log in</Link>
      </nav>}
    </div>
  </header>;
}
